import { Modal, Typography } from "@material-ui/core";
import React from "react";
import { getTerminalId } from "../../../services";
import { useStore } from "../../../store";
import { PaymentMethod } from "../../../types";
import { Button } from "../../index";
import useStyles from "./styles";

export interface VisitorPaymentMethodModalProps {
  open: boolean;
  isVariablePrice?: boolean;
  onClose?: () => void;
  isMarket?: boolean;
  isPixEnabled?: boolean;
}
export const VisitorPaymentMethodModal: React.FC<
  VisitorPaymentMethodModalProps
> = ({
  open,
  isVariablePrice = false,
  onClose,
  isMarket = false,
  isPixEnabled = true,
}) => {
  const Styles = useStyles();
  const { navigation } = useStore();

  const handleManualPurchase = async (type: string, paymentMethod: PaymentMethod) => {
    if (isMarket) {
      // For market, go to name input first, then to payment confirmation
      navigation.navigateTo("/confirm-manual-purchase", {
        state: {
          type: "market-visitor",
          paymentMethod,
        },
      });
    } else {
      navigation.navigateTo("/confirm-manual-purchase", {
        state: {
          type,
          isVariablePrice,
          paymentMethod,
        },
      });
    }
  };

  return (
    <Modal className={Styles.modal} open={open} onClose={onClose}>
      <div className={Styles.modalView}>
        <Typography component="span" className={Styles.title}>
          Finalizar Compra
        </Typography>
        <Typography component="span" className={Styles.message}>
          Escolha o método de pagamento
        </Typography>
        <div className={Styles.actions}>
          {isPixEnabled && (
            <Button onClick={() => handleManualPurchase("visitor", PaymentMethod.PIX)}>
              Pix
            </Button>
          )}
          {
                  getTerminalId() && (
                    <>
                      <Button
                        onClick={() =>
                          handleManualPurchase("visitor", PaymentMethod.DEBIT_CARD)}
                      >
                        Cartão de Debito
                      </Button>
                      <Button
                        onClick={() =>
                          handleManualPurchase("visitor", PaymentMethod.CREDIT_CARD)}
                      >
                        Cartão de Crédito
                      </Button>
                    </>
                  )
                }

        </div>
      </div>
    </Modal>
  );
};
